import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col, Button, Badge, CardDeck, Tooltip, Form, Input } from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../i18next';
import Pagination from 'react-js-pagination';

import ConfirmationScreen from '../settings/pos/ConfirmationScreen';
import {
    PRICE_DISCOUNT,
    COMBO_DEAL,
    FREE_PRODUCT,
    DEFAULT_PAGE_SIZE,
    DEFAULT_PAGING_RANGE
} from '../../../utils/Constants';
import {
    loadPromotions,
    loadPromotionsSummary,
    deletePromotion,
    loadMenus
} from '../../../actions/index';
import PromotionScreen from './PromotionScreen';
import PromotionCard from './PromotionCard';
import PromotionProviders from '../../promotionProviders/PromotionProviders';
import SearchButton from '../../common/SearchButton';

class PromotionsScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            promotionsMakerInEditMode: false,
            promotionsMakerInCopyMode: false,
            promotionsMakerOpened: false,
            selectedPromotion: { id: -1 },
            deletePromotionConfirmationOpened: false,
            addPromoBtTooltipOpen: false,
            promoCode: '',
            currentPageNumber: 0
        };

        this.togglePromotionsMaker = this.togglePromotionsMaker.bind(this);
        this.toggleConfirmationScreen = this.toggleConfirmationScreen.bind(this);
        this.toggleAddPromoBtnTooltip = this.toggleAddPromoBtnTooltip.bind(this);
        this.deletePromotion = this.deletePromotion.bind(this);
        this.search = this.search.bind(this);
        this.changeState = this.changeState.bind(this);
        this.clearSearch = this.clearSearch.bind(this);
    }

    componentDidMount() {
        const { id } = this.props.match.params;

        this.props.loadPromotions(id, '', this.state.currentPageNumber, '');
        // this.props.loadPromotionsSummary(id, '', this.state.currentPageNumber, '');
        this.props.loadMenus(id);
    }

    changeState({ target }) {
        this.setState({
            [target.name]: target.value
        })
    }

    search() {
        const { id } = this.props.match.params;
        this.props.loadPromotions(id, '', 0, this.state.promoCode)
    }

    handlePageChange(pageNumber) {
        const { id } = this.props.match.params;
        this.setState({
            currentPageNumber: (pageNumber - 1)
        }, () => {
            this.props.loadPromotions(id, '', this.state.currentPageNumber, this.state.promoCode)
        }) 
    }

    clearSearch() {
        const { id } = this.props.match.params;

        this.setState({
            promoCode: '',
            currentPageNumber: 0
        }, () => {
            this.props.loadPromotions(id, '', this.state.currentPageNumber, this.state.promoCode);
        })
    }

    renderPagination() {
        return (
            <Col xs={12} style={{display: 'flex', justifyContent: 'flex-end'}}>
                <Pagination
                    activePage={this.props.promotionsSearchResponse.number + 1}
                    itemsCountPerPage={DEFAULT_PAGE_SIZE}
                    totalItemsCount={this.props.promotionsSearchResponse.totalElements}
                    pageRangeDisplayed={DEFAULT_PAGING_RANGE}
                    itemClass='page-item'
                    linkClass='page-link'
                    onChange={this.handlePageChange.bind(this)}
                />
            </Col>
        );
    }

    renderSummaryAndPromoBtn() {
        const { rowStyler } = styles;

        return (
            <Row style={rowStyler}>
                {/* {this.renderPromotionsSummary()} */}
                {this.renderSearch()}
                {this.renderAddPromoBtn()}
            </Row >
        );
    }

    // renderPromotionsSummary() {
    //     const { summary, colElement, badge } = styles;
    //     const allPromotions = this.props.promotionsSummary.length;
    //     let priceDiscounts = 0;
    //     let freeProducts = 0;
    //     let comboDeals = 0;

    //     this.props.promotionsSummary.map((promotion, i) => {
    //         const promotionDiscountType = promotion.discountType;

    //         switch (promotionDiscountType) {
    //             case PRICE_DISCOUNT:
    //                 return priceDiscounts++;
    //             case COMBO_DEAL:
    //                 return comboDeals++;
    //             case FREE_PRODUCT:
    //                 return freeProducts++;
    //         }
    //     });

    //     return (
    //         <Col xs={12} sm="auto" md={8} style={summary}>
    //             <span style={colElement} onClick={() => this.performSearch('')}>{i18n.t('screens:promotionsScreen.summaryAll')}<span style={badge}><Badge color="primary">{allPromotions}</Badge></span></span>
    //             <span style={colElement} onClick={() => this.performSearch(PRICE_DISCOUNT)}>{i18n.t('screens:promotionsScreen.summaryPrice')}<span style={badge}><Badge color="primary">{priceDiscounts}</Badge></span></span>
    //             <span style={colElement} onClick={() => this.performSearch(FREE_PRODUCT)}>{i18n.t('screens:promotionsScreen.summaryProduct')}<span style={badge}><Badge color="primary">{freeProducts}</Badge></span></span>
    //             <span style={colElement} onClick={() => this.performSearch(COMBO_DEAL)}>{i18n.t('screens:promotionsScreen.summaryCombo')}<span style={badge}><Badge color="primary">{comboDeals}</Badge></span></span>
    //         </Col>
    //     );
    // }

    renderSearch() {
        const { promoCode } = this.state;
        const { paddingLeftRight } = styles;

        return (
            <Col style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '20px', paddingLeft: '30px' }} xs="auto" sm={10} >
                <Form id='advanceSearchForm' onKeyUp={this.onKeyUp}>
                    <Row>
                        <Col style={{paddingLeft: '0px'}}>
                            <Input 
                            type="text" 
                            name="promoCode" 
                            id="promoCode" 
                            placeholder={i18n.t('screens:paymentScreen.promoCode')} 
                            value={promoCode} 
                            onChange={this.changeState} />
                        </Col>
                        <Col style={{ maxWidth: 190, display: 'flex', alignItems: 'flex-end', flexDirection: 'column', padding: 0, marginLeft: '15px' }}>
                            <SearchButton 
                                search={this.search} 
                            />
                            <Button
                                color="link"
                                style={{ paddingTop: 0, paddingRight: 0, minWidth: 80, textAlign: 'right' }}
                                onClick={() => this.clearSearch()}
                                >
                                    {i18n.t('common:searchForms.clear')}
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Col>
        )
    }

    performSearch(target) {
        const { id } = this.props.match.params;

        this.setState({
            promoCode: '',
            currentPageNumber: 0
        }, () => this.props.loadPromotions(id, target, this.state.currentPageNumber))
    }

    renderAddPromoBtn() {
        const { btnColumn } = styles;
        const isDisabled = this.props.menus.length === 0 ? true : false;

        return (
            <Col style={btnColumn}>
                <div id="addPromoBtTooltipOpen">
                    <div className="disabledButtonOverlay" hidden={!isDisabled}></div>
                    <Button color="primary" disabled={isDisabled}
                        onClick={() => {
                            this.setState({
                                ...this.state,
                                promotionsMakerOpened: !this.state.promotionsMakerOpened,
                                promotionsMakerInEditMode: false,
                                selectedPromotion: { id: -1 }
                            });
                        }
                        }>
                        <MaterialIcon icon="add_circle_outline" color="#fff" size={20} />
                            &nbsp;{i18n.t('common:buttons.addPromotion')}
                    </Button>
                    <Tooltip
                        placement="top" target="addPromoBtTooltipOpen" disabled={!isDisabled}
                        isOpen={this.state.addPromoBtTooltipOpen} toggle={this.toggleAddPromoBtnTooltip}>
                        {i18n.t('screens:promotionsScreen.disabledBtnTooltip')}
                    </Tooltip>
                </div>
            </Col>
        );
    }

    toggleAddPromoBtnTooltip() {
        this.setState({
            addPromoBtTooltipOpen: !this.state.addPromoBtTooltipOpen
        });
    }

    togglePromotionsMaker() {
        this.setState({ ...this.state, promotionsMakerOpened: !this.state.promotionsMakerOpened });
    }

    toggleConfirmationScreen() {
        this.setState({ ...this.state, deletePromotionConfirmationOpened: !this.state.deletePromotionConfirmationOpened });
    }

    deletePromotion() {
        let promotionId = this.state.selectedPromotion.id;
        let restaurantId = this.props.match.params.id;
        let discountType = '';

        this.props.deletePromotion(promotionId, () => {
            // this.props.loadPromotionsSummary(restaurantId, discountType, currentPageNumber, promoCode);
            this.props.loadPromotions(restaurantId, discountType, this.state.currentPageNumber, this.state.promoCode);
        });
    }

    renderPromotionsDeck() {
        return (
            <Row>
                <Col>
                    <CardDeck>{this.renderPromoCards()}</CardDeck>
                </Col>
            </Row>
        );
    }

    renderPromoCards() {
        const { promotions } = this.props;

        return promotions.map((promotion, i) => {
            return (
                <PromotionCard
                    key={i}
                    index={i}
                    promotion={promotion}
                    styles={styles}
                    onEdit={() => {
                        this.setState({
                            ...this.state,
                            promotionsMakerOpened: !this.state.promotionsMakerOpened,
                            promotionsMakerInEditMode: true,
                            promotionsMakerInCopyMode: false,
                            selectedPromotion: promotion
                        });
                    }}
                    onDelete={() => {
                        this.setState({
                            ...this.state,
                            deletePromotionConfirmationOpened: true,
                            selectedPromotion: promotion
                        })
                    }}
                    onCopy={() => {
                        this.setState({
                            ...this.state,
                            promotionsMakerOpened: !this.state.promotionsMakerOpened,
                            promotionsMakerInEditMode: false,
                            promotionsMakerInCopyMode: true,
                            selectedPromotion: promotion
                        });
                    }}
                />
            );
        });
    }

    handlePromotionPartnerLogic = () => {

        const { type, chainLevelPromotionSettings, chainPromotionPartnerType } = this.props.promotionProviders;

        if (!type) {
            return false;
        }

        if (!chainLevelPromotionSettings && type.id === 2) {

            return true;
        } else if (chainLevelPromotionSettings && chainPromotionPartnerType.id === 2) {

            return true;
        }

        return false;
    }

    render() {

        const { containerStyle, promoProvidersContainer } = styles;
        const textData = {
            header: i18n.t('screens:promotionsScreen.deletePromo'),
            firstRow: i18n.t('screens:promotionsScreen.deleteConfirmation'),
        };

        const additionalStyles = {};
        const isPromoSettingsHidden = this.handlePromotionPartnerLogic();
        if (isPromoSettingsHidden) {
            additionalStyles.borderBottom = 'none';
        }

        return (
            <Container fluid style={containerStyle}>
                <div style={{ ...promoProvidersContainer, ...additionalStyles }}>
                    <PromotionProviders />
                </div>
                {isPromoSettingsHidden ? null : this.renderSummaryAndPromoBtn()}
                {/* {isPromoSettingsHidden ? null : this.renderSearch()} */}
                {isPromoSettingsHidden ? null : this.renderPromotionsDeck()}
                {isPromoSettingsHidden ? null : this.renderPagination()}
                <PromotionScreen
                    restaurant={this.props.restaurant}
                    restaurantId={this.props.match.params.id}
                    selectedPromotion={this.state.selectedPromotion}
                    isOpen={this.state.promotionsMakerOpened}
                    onToggle={this.togglePromotionsMaker}
                    editMode={this.state.promotionsMakerInEditMode}
                    copyMode={this.state.promotionsMakerInCopyMode}
                    currentPageNumber={this.state.currentPageNumber}
                    promoCode={this.state.promoCode}
                />
                <ConfirmationScreen
                    isOpen={this.state.deletePromotionConfirmationOpened}
                    onToggle={this.toggleConfirmationScreen}
                    onSave={this.deletePromotion}
                    message={textData}
                />
            </Container>
        );
    }
}


const mapStateToProps = state => {
    return {
        promotions: state.promotions,
        promotionsSummary: state.promotionsSummary,
        menus: state.menus,
        restaurant: state.restaurant,
        promotionProviders: state.promotionProviders,
        promotionsSearchResponse: state.promotionsSearchResponse
    };
};

export default connect(mapStateToProps, { loadPromotions, deletePromotion, loadPromotionsSummary, loadMenus })(PromotionsScreen);

const styles = {
    containerStyle: {
        padding: "0 0 0 10px"
    },
    rowStyler: {
        marginTop: 20,
        marginBottom: 20
    },
    btnColumn: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    summary: {
        display: 'flex',
        alignItems: 'center',
        fontSize: 14
    },
    colElement: {
        marginRight: 20,
        color: '#0288D1',
        cursor: 'pointer'
    },
    badge: {
        paddingLeft: 8
    },
    card: {
        margin: 0,
        marginBottom: 30
    },
    cardBody: {
        padding: "15px 15px 0 15px"
    },
    cardTitle: {
        fontWeight: 900,
        fontSize: 14
    },
    cardTitleExpired: {
        fontWeight: 900,
        fontSize: 14,
        color: '#cfcccf'
    },
    cardSubtitle: {
        color: '#759F2E',
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: 0,
        fontSize: 14
    },
    cardSubtitleExpired: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: 0,
        fontSize: 14,
        color: '#cfcccf'
    },
    dealType: {
        display: 'flex',
        alignItems: 'center',
        fontSize: 12
    },
    dealTypeText: {
        paddingTop: 4
    },
    dealTypeTextExpired: {
        paddingTop: 4,
        color: '#cfcccf'
    },
    iconColor: {
        color: 'black'
    },
    iconColorExpired: {
        color: '#cfcccf'
    },
    cardText: {
        fontSize: 12
    },
    cardTextExpired: {
        fontSize: 12,
        color: '#cfcccf'
    },
    btnColumn: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    btnStyle: {
        padding: 0,
        marginLeft: 10,
        fontSize: 14
    },
    cursorPointer: {
        cursor: 'pointer'
    },
    promoProvidersContainer: {
        marginBottom: 20,
        paddingBottom: 12,
        borderBottom: '1px solid #dee2e6'
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/promotions/PromotionsScreen.js